export const FREE_USER_MESSAGE_SEND_LIMIT = 1000;

export const SEEN_SEND_LIMIT_NOTIFICATION_TABLE_KEY =
  'seenSendLimitNotificationTable';
